import { css } from "@emotion/react";

export const navWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem auto 0;
`;

export const barWrapper = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  list-style: none;
`;
